import React from 'react'
import { BtInput } from '@linqpal/components/src/ui'
import { observer } from 'mobx-react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { validators } from '@linqpal/models'

const { validateEmail } = validators

function validate(value) {
  return validateEmail(value)
}

function Email(props) {
  const { t } = useTranslation('application')
  const { doc, group, item, onValueUpdate } = props
  const model = useEditorModel<string>(
    doc,
    group,
    item,
    onValueUpdate,
    '',
    validate,
  )
  return (
    <BtInput
      model={model}
      name="value"
      label={t('Business.EmailLabel')}
      testID="BusinessEmailInput"
    />
  )
}

export default {
  title: 'Business.Email',
  component: observer(Email),
  showFooterMessage: true,
}
